import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30e1958c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Parámetros y Valores")
const _hoisted_2 = { style: {"margin-top":"15px"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Añadir Parámetro ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Cancelar")

import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { postTrainingData } from "@/service/trainingData.service";
import type { Parameter } from "@/types/parameter.type";
import type { Container } from "@/types/container.type";


export default /*#__PURE__*/_defineComponent({
  props: {
    visible: { type: Boolean },
    defaultDate: null,
    container: null,
    availableParameters: null
  },
  emits: ["update:visible", "saved"],
  setup(__props: any, { emit }) {

const props = __props as {
  visible: boolean;
  defaultDate: string | Date | null;
  container?: Container;
  availableParameters: Parameter[];
}





const formRef = ref();
const loading = ref(false);

const form = reactive({
  dateTime: null as any,
  status: "ORIGINAL",
  event: "",
  lines: [{ codeParameter: null as Parameter | null, value: 0 }],
});

const rules = {
  dateTime: [{ required: true, message: "Fecha obligatoria", trigger: "blur" }],
  status: [{ required: true, message: "Estado obligatorio", trigger: "blur" }],
};

const initForm = () => {
  form.dateTime = props.defaultDate;
  form.lines = [{ codeParameter: null, value: 0 }];
  form.event = "";
};

const addLine = () => {
  form.lines.push({ codeParameter: null, value: 0 });
};

const removeLine = (index: number) => {
  form.lines.splice(index, 1);
};

const submitForm = async () => {
  if (!formRef.value) return;

  try {
    await formRef.value.validate();
    loading.value = true;

    const payload = form.lines.map((line) => ({
      dateTime: new Date(form.dateTime).toISOString(),
      raw: line.value,
      value: line.value,
      clean: line.value,
      magnitude: line.codeParameter?.name || "",
      origin: "SINTETICO",
      status: form.status,
      event: form.event,
      samplingPointType: props.container?.containerType?.name,
      container: props.container,
      codeParameter: line.codeParameter,
    }));

    await postTrainingData(payload);

    ElMessage.success(`${payload.length} parámetros guardados.`);
    emit("saved");
    emit("update:visible", false);
  } catch (error: any) {
    console.error(error);
    ElMessage.error("Error al guardar los datos.");
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:visible', $event))),
    title: "Nuevo dato sintético",
    width: "750px",
    onOpen: initForm
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:visible', false)))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        loading: loading.value,
        onClick: submitForm
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Guardar todo (" + _toDisplayString(_unref(form).lines.length) + ") ", 1)
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: _unref(form),
        rules: rules,
        "label-width": "100px",
        "label-position": "left"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Fecha/Hora",
                    prop: "dateTime"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _unref(form).dateTime,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).dateTime) = $event)),
                        type: "datetime",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Estado",
                    prop: "status"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(form).status,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).status) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Evento",
                    prop: "event"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(form).event,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).event) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_divider, { "content-position": "left" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).lines, (line, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "parameter-row"
            }, [
              _createVNode(_component_el_row, {
                gutter: 12,
                align: "middle"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: 'Parám. ' + (index + 1),
                        "label-width": "70px",
                        prop: 'lines.' + index + '.codeParameter',
                        rules: { required: true, message: 'Selecciona parámetro', trigger: 'change' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: line.codeParameter,
                            "onUpdate:modelValue": ($event: any) => ((line.codeParameter) = $event),
                            placeholder: "Seleccionar...",
                            filterable: "",
                            "value-key": "id",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.availableParameters, (param) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: param.id,
                                  label: param.name,
                                  value: param
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["label", "prop"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Valor",
                        "label-width": "50px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            modelValue: line.value,
                            "onUpdate:modelValue": ($event: any) => ((line.value) = $event),
                            style: {"width":"100%"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_col, {
                    span: 4,
                    style: {"text-align":"right"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "danger",
                        icon: "Delete",
                        circle: "",
                        plain: "",
                        onClick: ($event: any) => (removeLine(index)),
                        disabled: _unref(form).lines.length === 1
                      }, null, 8, ["onClick", "disabled"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_button, {
              type: "primary",
              icon: "Plus",
              plain: "",
              onClick: addLine
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})